import { ColumnFieldType } from './SPListItemEnums';
import { ISPListField } from '../spListItemRetriever/interfaces/ISPGetItemResponse';

export function getColumnFieldType(listField: ISPListField): ColumnFieldType {
    let fieldType: string = listField.FieldType;

    if (fieldType === 'Calculated') {
        fieldType = listField.ResultType;
    }

    // Special logic for particular computed fields with known types
    if (fieldType === 'Computed') {
        switch (listField.Name) {
            case 'FileSizeDisplay':
                return ColumnFieldType.FileSize;
            case 'ImageSize':
                return ColumnFieldType.ImageSize;
            case 'SharedWith':
                return ColumnFieldType.SharedWith;
            case '_IsRecord':
                return ColumnFieldType.ComplianceRecordFlag;
            case 'ThumbnailOnForm':
            case 'Thumbnail':
                return ColumnFieldType.Thumbnail;
            default:
                return ColumnFieldType.Computed;
        }
    }

    // If the field type corresponds directly to an enum value's name, use that enum value
    let fieldTypeEnum = ColumnFieldType[fieldType];
    if (typeof fieldTypeEnum === 'number') {
        return fieldTypeEnum;
    }

    switch (fieldType) {
        case 'UserMulti':
            return ColumnFieldType.User;
        case 'URL':
            return listField.Format === 'Hyperlink' ? ColumnFieldType.Hyperlink : ColumnFieldType.Image;
        case 'LookupMulti':
            return ColumnFieldType.Lookup;
        case 'MultiChoice':
            return ColumnFieldType.Choice;
        case 'TaxonomyFieldType':
        case 'TaxonomyFieldTypeMulti':
            return ColumnFieldType.Taxonomy;
    }

    // text type is always the default.
    return ColumnFieldType.Text;
}